export default __webpack_public_path__ + "static/media/Alfa Laval.1efe7e88.png";